import React from 'react';

import withAppState from '../mobx/withAppState';
import MenuFooter from './MenuFooter';
import Header from './Header';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faStar,
    faMapMarkerAlt
} from '@fortawesome/free-solid-svg-icons';
import { ReactComponent as Crosshairs } from '../assets/img/crosshairs.svg';
import { ReactComponent as CrosshairsCircle } from '../assets/img/crosshairs-circle.svg';
import binos from '../assets/img/binoculars.svg';
import mapmarkerWireframe from '../assets/img/mapmarker-wireframe.png'
import GeoLocationRose from '../assets/img/geoLocationRose.svg';
import CloseIconRose from '../assets/img/closeIconRose.svg';
import twitterIcon from '../assets/img/icons/twitter.svg';
import instagramIcon from '../assets/img/icons/instagram.svg';
import facebookIcon from '../assets/img/icons/facebook.svg';
import deliveryMan from '../assets/img/deliveryMan.svg';
import MenuFooterLinks from '../components/MenuFooterLinks';
import makeCancelable from '../helpers/PromiseWrapper';
import DigitalMenuHeader from './DigitalMenuHeader';
const mapmarker = <img alt="distance" src={mapmarkerWireframe} />;


const WAIT_INTERVAL = 500;
const LOADING_TIMEOUT_SECONDS = 7;

class RestaurantSearch extends React.Component {
    constructor(props) {
        super(props);
        this.locationSearch = React.createRef();
        this.state = {
            results: this.props.restaurantSearchCache,
            displayingNearby: false,
            nearbyResults: {},
            searchString: '',
            loading: false,
            searching: false,
            locationModalShow: false,
            resultMessage: 'Use my location',
            favRest:
                !!this.props.customer &&
                    !!this.props.customer.favouriteRestaurants
                    ? this.props.customer.favouriteRestaurants
                    : null,
            isResultCardVisible: false,
            isInputFocused: false,
            showRestaurantSearchPopup: false
        };
        this.timer = null;
        this.requests = [];
        this.locationRequests = [];
        this.loadingTimeout = null;
    }


    componentDidMount() {
        if (this.locationSearch) {
            this.handleLocationSearch();
        }
    }

    cancelLocationRequests() {
        for (let i = 0; i < this.locationRequests.length; i++) {
            this.locationRequests[i].cancel();
        }
    }

    componentWillUnmount() {
        for (let i = 0; i < this.requests.length; i++) {
            this.requests[i].cancel();
        }
        this.cancelLocationRequests();
    }

    async handleSearchChange() {
        clearTimeout(this.timer);
        this.timer = setTimeout(async () => {
            await this.triggerSearch();
            this.setState((prevState) => ({
                isResultCardVisible: prevState.searchString.trim() !== '' || prevState.searching,
            }));
        }, WAIT_INTERVAL);
    }

    toggleLocationModal = () => {
        this.setState({ locationModalShow: !this.state.locationModalShow })
    }

    async triggerSearch() {
        let searchInput = document.getElementsByName('search-input')[0];

        if (!!searchInput) {
            const searchString = searchInput.value;
            this.setState({
                searchString
            });
            if (searchString.trim() !== '') {
                this.cancelLocationRequests();

                if (!this.loadingTimeout) {
                    this.loadingTimeout = setTimeout(() => {
                        this.setState({ loading: true });
                    }, LOADING_TIMEOUT_SECONDS * 1000);
                }

                var request = makeCancelable(
                    fetch('api/Restaurant/LookupName/' + searchString)
                );
                this.setState({ searching: true });
                this.requests.push(request);
                let response = await request;
                if (response.status === 200) {
                    return response
                        .json()
                        .catch(err => {
                            this.loadingTimeout = clearTimeout(this.loadingTimeout);
                            this.setState({ loading: false, searching: false });
                        })
                        .then(data => {
                            this.loadingTimeout = clearTimeout(this.loadingTimeout);
                            this.setState({
                                displayingNearby: false,
                                results: data,
                                loading: false,
                                searching: false
                            });
                        });
                } else {
                    this.loadingTimeout = clearTimeout(this.loadingTimeout);
                    this.setState({ loading: false, searching: false });
                }
            } else {
                this.setState({
                    displayingNearby: true
                });
            }
        }
    }

    getLocation() {
        navigator.geolocation.getCurrentPosition(
            position => {
                // const lat = position.coords.latitude;
                // const lng = position.coords.longitude;
                const lat = 53.345238;
                const lng = -6.280838;
                if (!this.loadingTimeout) {
                    this.loadingTimeout = setTimeout(() => {
                        this.setState({ loading: true });
                    }, LOADING_TIMEOUT_SECONDS * 1000);
                }
                this.setState({ searching: true });
                let request = makeCancelable(
                    fetch(`api/Restaurant/LookupLatLong/${lat}/${lng}`)
                );
                this.locationRequests.push(request);
                request
                    .then(response => {
                        if (response.status === 200) {
                            response.json().then(data => {
                                this.loadingTimeout = clearTimeout(this.loadingTimeout);
                                this.setState({
                                    nearbyResults: data,
                                    displayingNearby: true,
                                    loading: false,
                                    searching: false
                                });
                            });
                        } else {
                            this.loadingTimeout = clearTimeout(this.loadingTimeout);
                            this.setState({
                                loading: false,
                                searching: false
                            });
                        }
                    })
                    .catch(err => {
                        console.error(err);
                        this.loadingTimeout = clearTimeout(this.loadingTimeout);
                        this.setState({
                            loading: false,
                            searching: false
                        });
                    });
            },
            error => {
                let resultMessage = 'Enable your location to discover nearby restaurants';

                this.setState({
                    loading: false,
                    searching: false,
                    resultMessage
                });

                console.log(error.code);
                console.log(error.message);


                // error.code can be:
                //   0: unknown error
                //   1: permission denied
                //   2: position unavailable (error response from location provider)
                //   3: timed out
            }
        );
    }


    async handleLocationSearch() {
        //  navigator.permissions is not supported on iOS
        if (navigator && navigator.permissions && navigator.permissions.query) {
            let permissionQuery = await navigator.permissions.query({
                name: 'geolocation'
            });
            var navigatorGeolocationState = permissionQuery.state;
            if (navigatorGeolocationState === 'prompt') {
                this.setState({
                    resultMessage: 'Would you like to search for nearby restaurants?',
                });
                this.getLocation();
            } else {
                this.getLocation();
            }
        } else {
            this.getLocation();
        }
    }

    handleRestaurantSelect(restaurant) {
        this.props.cacheRestaurantSearch(this.state.results);
        this.props.handleRestaurantSelect(restaurant);
    }

    displayResults() {
        let results = this.state.displayingNearby
            ? this.state.nearbyResults
            : this.state.results;

        if (!!results && !!results.restaurants) {
            var restaurants = results.restaurants;

            if (restaurants.length > 0) {
                var output = [];

                if (this.state.searching === true) {
                    output.push(
                        <div className="result-card header">
                            <div className="loading-text">
                                <div className={`lds-dual-ring main-loading`}></div>
                                <div className={`restaurant-address`}>
                                    {this.state.loading === true ? (<p className="search-loading">Sorry, we're taking longer than usual to process your search</p>
                                    ) : <p>Searching...</p>}
                                </div>
                            </div>
                        </div>
                    )
                } else {
                    if (this.state.displayingNearby === true) {
                        output.push(
                            <div
                                key={'nearby'}
                                className="result-card header"
                            >
                                <div className="restaurant-address">Search Results</div>
                            </div>
                        );
                    } else {
                        output.push(
                            <div
                                key={'results'}
                                className="result-card header"
                            >
                                <div className="restaurant-address">Search results</div>
                            </div>
                        );
                    }
                }

                output.push(
                    restaurants.map((restaurant, index) => {
                        return this.restaurantResult(restaurant, index);
                    })
                );

                return output;
            }
        }
        return null;
    }

    displayFavourites() {
        if (
            !!this.props.customer &&
            !!this.props.customer.favouriteRestaurants
        ) {
            const favouriteRestaurants = this.props.customer.favouriteRestaurants;
            return (
                <div className="restaurant-favourites">
                    <div className="myPeFavourites">
                        <h3>My Favourites</h3>
                        {favouriteRestaurants.map((restaurant, index) => {
                            return this.restaurantResult(restaurant, index);
                        })}
                    </div>
                </div>
            );
        } else {
            return null;
        }
    }

    restaurantResult(restaurant, index) {
        const { customer } = this.props;
        const starIcon = <FontAwesomeIcon icon={faStar} />;
        let star = null;
        if (customer) {
            const { favouriteRestaurants } = customer;
            const firstFavRestaurantId = (favouriteRestaurants && favouriteRestaurants.length > 0) ? favouriteRestaurants[0].id : null
            if (firstFavRestaurantId === restaurant.id) {
                star = <span className="fav-restaurant-star">{starIcon}</span>;
            }
        }


        let distance = null;
        if (this.state.displayingNearby === true && !!restaurant.distance)
            distance = (Number(restaurant.distance) / 1000).toFixed(1) + 'km';
        return (
            <div
                key={index}
                className="result-card clickable"
                onClick={() => this.handleRestaurantSelect(restaurant)}
            >
                <div className="restaurant-name">
                    <h3>
                        {`${restaurant.name}`}
                    </h3>
                </div>
                <div>
                    {!!distance && (
                        <span className="fav-restaurant-distance">
                            {mapmarker} <strong>{distance}</strong>
                        </span>
                    )}
                </div>

                {!!this.props.customer && !!this.props.customer.favouriteRestaurants && (
                    <div className="restaurant-icon">{!!star && star}</div>
                )}
                {!!restaurant.fullAddress && (
                    <div className="restaurant-address">{restaurant.fullAddress}</div>
                )}
            </div>
        );
    }

    handleInputFocus = () => {
        this.setState({ isInputFocused: true });
    }

    handleInputBlur = () => {
        this.setState({ isInputFocused: false });
    }

    showPopupDisplay = () => {
        this.setState({showRestaurantSearchPopup: true});
    }

    hidePopupDisplay = () => {
        this.setState({showRestaurantSearchPopup: false});
    }
    render() {

        const resultMessage = this.state.resultMessage;
        const isInputFocused = this.state.isInputFocused;

        const restaurantSearchPopup = this.state.showRestaurantSearchPopup ? 'overlay active showing' : "overlay";
        return (
            <>
                <div className={`menu-page home`}>
                    <div>
                        <Header logo={this.props.logo} />

                        <div className="menu">
                        <DigitalMenuHeader popUpDisplayHandler={this.showPopupDisplay}/>
                        
                         {/* Restaurant search popup section */}
                        <section className={restaurantSearchPopup}>
                            <div className="overlay-content-container fixed-top-scroll">
                                <div className="overlay-content-inner-container restaurant-overlay">
                                    <button className="overlay-close overlay-close-restaurant" onClick={this.hidePopupDisplay}><img src={CloseIconRose} alt="Close find restaurant overlay"/></button>
                                    <div className="overlay-content overlay-header pb-22-i">
                                        <h3 className="overlay-content-heading txt-center">RESTAURANTS</h3>
                                        <div className="padding-bottom-large">
                                            <div className="restaurant-search-container">
                                                <div className="restaurant-search-container">
                                                    <div className="global-restaurant-search-container large-results flex">
                                                            <div className="search-restaurant-input-wrapper">
                                                                <input 
                                                                    className="search-restaurant-input input is-col-12"
                                                                    ref={input => input && input.focus()}
                                                                    onFocus={this.handleInputFocus}
                                                                    onBlur={this.handleInputBlur}
                                                                    tabIndex="0"
                                                                    type="text"
                                                                    autoComplete="off"
                                                                    name="search-input"
                                                                    placeholder="Search location"
                                                                    onKeyDown={async () => await this.handleSearchChange()}
                                                                    />
                                                                    <i className="fas fa-circle-notch"></i>
                                                            </div>
                                                            <div className="search-results-container IEfix is-col-12 btn-shadow txt-black">
                                                                <div className="search-results search-results-restaurants">
                                                                    
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                <div className="restaurant-search-geolocation-icon">
                                                    <button className="btn-geolocation" onClick={() => this.setState((prevState) => ({ isResultCardVisible: !prevState.isResultCardVisible }))}>
                                                        <img src={GeoLocationRose} alt="find your nearest restaurant"/>
                                                    </button>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="full-width">
                                                    
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="is-row justify-around">
                                        <div className="is-flex is-flex-col tabs-container full-width">
                                            <div className="tab active">                        
                                                <div className="transparent-tabs tabs-container find-order-book bg-light-grey is-radius-8-b">
                                                    
                                                    <div className="tab active">
                                                        <div className="px-6 py-8">
                                                            {/* <ul className="is-flex is-flex-col gap-4">
                                                                <li className="restaurant-info p-6 txt-left is-flex is-flex-col bg-lighter-grey is-radius-4">
                                                                    <div className="pb-2">
                                                                        <h5>
                                                                            <a className="list-item-heading gap-4 gap-2-mobile link is-flex-col-mobile is-not-underlined">
                                                                                <span>Twickenham York Street</span>
                                                                                <span className="is-flex is-row gap-2">
                                                                                    <img className="locationPin" src="/assets/img/rebrand/locationpin.svg"/>
                                                                                    <div className="is-semibold-primary-font">
                                                                                        <span>1.9</span>mi
                                                                                    </div>
                                                                                </span>
                                                                            </a>
                                                                        </h5>
                                                                    </div>
                                                                    <div className="pb-4 is-flex is-flex-col gap-2">
                                                                        <p>21 York Street, Twickenham, Middlesex, TW1 3JZ</p>
                                                                    </div>                                                    
                                                                </li>
                                                            </ul> */}

                                                            <div className="result-card-container" style={{ display: this.state.isResultCardVisible ? 'block' : 'none' }}>
                                                                {this.displayResults() || (
                                                                    <div className="no-results">
                                                                        <div className="instruction"
                                                                            onClick={() => this.handleLocationSearch()}>
                                                                            {resultMessage}
                                                                        </div>
                                                                    </div>
                                                                )}
                                                                {this.displayFavourites()}
                                                            </div>
                                                        </div>
                                                    </div>                                    
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        {/* Restaurant search popup section */}                        
                            <div className="home-card-intro">
                                <div style={{ display: 'flex', flexDirection: 'row' }} className="home-card-intro-inner">
                                    <div className="is-1-col-mobile is-2-col-tablet is-2-col-desktop" />
                                    <div className="home-card-title is-8-col-desktop is-10-col-mobile is-justify-center">
                                        {!this.props.isCheckInJourney &&
                                            <div className="home-card-title">
                                                <div className="home-card-title-inner">
                                                    <h3>MENU</h3>
                                                </div>
                                            </div>}
                                        {this.props.isCheckInJourney &&
                                            <div className="home-card-title">
                                                <div className="home-card-title-inner">
                                                    <h3>Test &amp; Trace Check-in</h3>
                                                    <p>Welcome to everyone's favourite pizzeria. Please click let’s get started to enter in your information for Test and Trace purposes whilst dining in our pizzerias.</p>
                                                </div>
                                            </div>}
                                    </div>
                                    <div className="is-1-col-mobile is-2-col-tablet is-2-col-desktop" />
                                </div>
                            </div>
                            <div ref={this.locationSearch} className="home-card-content">
                                <div className="home-card-content-inner">
                                    {this.props.children}
                                    <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                                        <div className='location-search-container'>
                                            <h3>Enter your postcode or location</h3>
                                            <div className="location-search-wrapper">
                                                <div className="preorder-search">
                                                    <div className="preorder-controls-wrapper">
                                                        <div className={`preorder-search-select ${isInputFocused ? 'focused' : ''}`}>
                                                            <input
                                                                onFocus={this.handleInputFocus}
                                                                onBlur={this.handleInputBlur}
                                                                ref={input => input && input.focus()}
                                                                tabIndex="0"
                                                                type="text"
                                                                autoComplete="off"
                                                                name="search-input"
                                                                className="preorder-search-input"
                                                                placeholder="Search location"
                                                                onKeyDown={async () => await this.handleSearchChange()}
                                                            ></input>
                                                            <div className="near-you-button-wrapper">
                                                                <button className="near-you-button-mobile" onClick={() => this.setState((prevState) => ({ isResultCardVisible: !prevState.isResultCardVisible }))}>
                                                                    <Crosshairs></Crosshairs>
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <button className="near-you-button" onClick={() => this.setState((prevState) => ({ isResultCardVisible: !prevState.isResultCardVisible }))}>
                                                            <CrosshairsCircle></CrosshairsCircle>
                                                        </button>
                                                    </div>
                                                    <div className="result-card-container" style={{ display: this.state.isResultCardVisible ? 'block' : 'none' }}>
                                                        {this.displayResults() || (
                                                            <div className="no-results">
                                                                <div className="instruction"
                                                                    onClick={() => this.handleLocationSearch()}>
                                                                    <div className="location-search-button icon"></div>
                                                                    {resultMessage}
                                                                </div>
                                                            </div>
                                                        )}
                                                        {this.displayFavourites()}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="home-card-content">
                                <div className="home-card-content-inner">
                                    <div className="search-binos-wrapper text-center">
                                        <img className='search-binos' src={binos}></img>
                                    </div>
                                    <p><a className="legal-modal-link" onClick={() => this.props.termAndConditionsModalMenu()}>Menu T&Cs</a></p>                            </div>
                            </div>
                        </div>
                    </div>
                    <MenuFooter
                        brand={'Milano'}
                    >
                        <MenuFooterLinks />
                    </MenuFooter>
                </div>
            </>
        );
    }
}

export default withAppState(RestaurantSearch,
    {
        mobXProps: ({
            restaurantSearchCache,
            privacyPolicyAndTermsConditionsModal,
            privacyPolicyAndTermsConditionsModalMenu,
            customer,
            isCheckInJourney
        }) => ({
            restaurantSearchCache,
            privacyPolicyAndTermsConditionsModal,
            privacyPolicyAndTermsConditionsModalMenu,
            customer,
            isCheckInJourney
        }),
        mobXActions: ({
            cacheRestaurantSearch,
            selectRestaurant,
            termAndConditionsModalMenu,
            closePrivacyPolicyTermsAndConditionsModal,
            getHomePageImage
        }) => ({
            cacheRestaurantSearch,
            selectRestaurant,
            termAndConditionsModalMenu,
            closePrivacyPolicyTermsAndConditionsModal,
            getHomePageImage
        })
    }
);